// extracted by mini-css-extract-plugin
export default {"row":"nJRTVRN_gD7q4j5zZr2_"};